import { DefaultFetchError,
  FetchCreate,
  FetchDelete,
  FetchGet,
  FetchUpdate,
  PagingDataResponse,
  PagingParams,
  useFetchCreate,
  useFetchDelete,
  useFetchGet,
  useFetchGetId,
  useFetchUpdate } from '../fetch';
import { CommentData } from './comments';
import { Country } from '../../store/country';
import { SEOResponse } from './SEO';

export interface InternationalResponse {
  id: string;
  isActive: boolean;
  description: string;
  country: Country;
  comments: CommentData[];
  seo: SEOResponse
  createdAt: string;
  updateAt: string;
}

export enum InternationalOrderColumn {
  ID = 'id',
  DESCRIPTION = 'description',
  COUNTRY = 'country.id',
  // USER_COUNT = 'userCount',
  CREATED = 'createdAt',
  UPDATED = 'updatedAt',
}

export interface InternationalGetParams extends PagingParams {
  orderByColumn?: InternationalOrderColumn;
}

export const useInternationalGet = (): FetchGet<
  PagingDataResponse<InternationalResponse>,
  InternationalGetParams
> => useFetchGet(
  'admin/internationals',
  {
    autoStart: false,
    startStateLoading: false,
  },
);

// export const useInternationalForSelectGet = (): FetchGet<
//   Pick<InternationalShort, 'id'>[],
//   InternationalGetParams
// > => useFetchGet(
//   'internationals/for-select',
//   {
//     autoStart: false,
//     startStateLoading: false,
//   },
// );

export interface InternationalById extends InternationalResponse {
  comments: CommentData[];
}

export const useInternationalGetById = (internationalId?: string): FetchGet<
  InternationalById
> => useFetchGetId(
  `admin/internationals/${internationalId}`,
  undefined,
  {
    autoStart: false,
    startStateLoading: false,
  },
);

export type InternationalCreateResponse = InternationalResponse
export type InternationalCreateData = Omit<InternationalResponse, 'id' | 'updateAt' | 'createdAt'>

export const useInternationalCreate = (): FetchCreate<
  InternationalCreateResponse,
  DefaultFetchError,
  InternationalCreateData
> => useFetchCreate(
  'admin/internationals',
  {
    autoStart: false,
    startStateLoading: false,
  },
);

export type InternationalUpdateResponse = InternationalCreateResponse;

export interface InternationalUpdateData extends Partial<InternationalCreateData> {
  id?: string;
}

export const useInternationalUpdate = (internationalId?: string): FetchUpdate<
  InternationalUpdateResponse,
  DefaultFetchError,
  InternationalUpdateData
> => useFetchUpdate(
  'admin/internationals',
  internationalId,
  {
    autoStart: false,
    startStateLoading: false,
  },
);

export const useInternationalDelete = (internationalId?: string): FetchDelete => useFetchDelete(
  'admin/internationals',
  internationalId,
  {
    autoStart: false,
    startStateLoading: false,
  },
);

export default {
  useInternationalGet,
  useInternationalGetById,
  useInternationalCreate,
  useInternationalUpdate,
  useInternationalDelete,
};
